var React = require('react');

function LvLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26.097 0H8.073v5.634h11.7v3.3h6.325z","fill":"#ff0146","key":0}),React.createElement("path",{"d":"M19.758 11.372l-5.974 11.542-1.845-5.8h-6.3V0H0v22.744h7.818l2.41 7.581h6.064L26.1 11.372z","fill":"#ff0146","key":1})]);
}

LvLogo.defaultProps = {"viewBox":"0 0 26 30.325"};

module.exports = LvLogo;

LvLogo.default = LvLogo;
